export enum PushNotificationsType {
  WORKER_ASSIGNED = "WORKER_ASSIGNED",
  RESERVATION_WORK_STARTED = "RESERVATION_WORK_STARTED",
  RESERVATION_WORK_FINISHED = "RESERVATION_WORK_FINISHED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  WORKER_IN_ROUTE = "WORKER_IN_ROUTE", // probably will be removed
}
